import React, {Component} from 'react'
import {createMedia} from '@artsy/fresnel'
import PropTypes from 'prop-types'
import 'semantic-ui-css/semantic.min.css';
import {
    Icon,
    Menu,
    Segment,
    Sidebar,
} from 'semantic-ui-react'
import {NavLink} from 'react-router-dom';
import styles from "../DennetMenu.module.css";

const {Media} = createMedia({
    breakpoints: {
        mobile: 0,
        tablet: 768,
        computer: 1024,
    },
})

class MobileContainer extends Component {
    state = {}

    render() {
        const {children, location} = this.props

        const isActive = (path) => location.pathname === path;
        return (
            <Media as={Sidebar.Pushable} at='mobile'>
                <Segment container vertical style={{
                    backgroundColor:'var(--background)',
                    minHeight: isActive('/') ? '100vh' : 'inherit',
                    position: 'relative',
                    paddingTop: 0,
                }} >

                    <Segment
                            textAlign='center'
                            style={{
                                padding: '0em 0em',
                            }}
                            basic
                            vertical
                        >
                            <Menu borderless secondary size='large' style={{borderBottom: '0px', marginBottom: '0px'}}>

                                <Menu.Item className={styles['custom-menu-item']} as={NavLink} to='/'
                                           active={isActive('/')}
                                           style={{borderColor: isActive('/') ? 'var(--primary-col)' : null}}>
                                    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'center', padding: '0em'}}>
                                        <Icon
                                            className={styles['custom-menu-item']} name='quote left'
                                            size='large'/>
                                    </div>
                                </Menu.Item>
                            </Menu>
                            {/*isActive('/') ? <HomepageHeading mobile/> : null} */}
                        </Segment>
                        {children}
                </Segment>
            </Media>
        )
    }
}

MobileContainer.propTypes = {
    children: PropTypes.node,
}


export default MobileContainer
